const UserColumn = ({
    row,
}) => {
    return row.User ? row.User.UserName : '';
};

export default UserColumn;